// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"de67a891","360":"9c577c39","870":"f5587425","952":"496beb54"}[chunkId] + ".chunk.js";
};